import React, { Component } from "react";

import Curousel from "../../components/carousel/homeCarousel";
import HavayarLogo from "../../components/ImageHandler/havayarLogoHandler";
import Item from "./itemCard";
import ItemCardExternal from "./itemCardExternal";
import article from "../../assets/images/general/article.svg";
import mainCertificate from "../../assets/images/general/mainـcertificate.svg";
import mainProduct from "../../assets/images/general/main_product.svg";
import mainServiceCenter from "../../assets/images/general/main_servicecentere.png";
import mainSizing from "../../assets/images/general/mainـsizing.svg";
import mainUserworkspace from "../../assets/images/general/mainـuserworkspace.svg";
import movie from "../../assets/images/general/movie.svg";

export default class mobileHomeContent extends Component {
  render() {
    return (
      <div id="Home" className="container">
        <Curousel />
        <div className="servicesbox">
          <p className="horizontalLine" />
          <div className="d-flex justify-content-center align-items-center">
            <div className="row servicesheader">
              <HavayarLogo />
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center">
            <div className="row">
              <Item
                id="ProductsItem"
                name="معرفی محصولات"
                title="تمام آنچه برای شما در نظر گرفته ایم"
                image={mainProduct}
                route="/products"
                fadeside="1"
              />
              <Item
                id="sizingItem"
                name="سایزینگ و انتخاب تجهیزات"
                title="برای انتخاب دقیقتر"
                image={mainSizing}
                route="/appSizing"
              />
              <Item
                id="educationItem"
                name="آموزش"
                title="برای حرفه ایی ها"
                image={mainCertificate}
                route="education"
                fadeside="1"
              />
              <Item
                id="profileItem"
                name="مرکز خدمات"
                title="خدمات پس از فروش"
                image={mainServiceCenter}
                route="serviceRequest"
              />
              <ItemCardExternal
                id="aticleItem"
                name="مقالات آموزشی"
                title="بخوانید تا بدانید"
                image={article}
                route="https://www.havayar.com/%d9%85%d9%82%d8%a7%d9%84%d8%a7%d8%aa-%d8%a2%d9%85%d9%88%d8%b2%d8%b4%db%8c/"
              />
              <ItemCardExternal
                id="movieItem"
                name="فیلم های آموزشی"
                title="ببینید تا بدانید"
                image={movie}
                route="https://www.havayar.com/%d9%81%db%8c%d9%84%d9%85-%d8%a2%d9%85%d9%88%d8%b2%d8%b4%db%8c/"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
